import React from 'react';
import classNames from 'classnames';

import NavbarLink from '../NavbarLink/NavbarLink';
import {NavbarButtonProps} from '../NavbarButton';
import CollapsibleSection from 'src/components/collapsible-section';

import styles from './styles.module.scss';

interface Props {
  title: React.ReactNode;
  routed?: boolean;
  menuItems?: NavbarButtonProps[];
  className?: string;
  experienceEverywhere?: boolean;
}

const MobileNavbarMenu = ({routed, menuItems, title, className, experienceEverywhere}: Props) => {
  const menuItemsRoutedFalse = (): NavbarButtonProps[] =>
    menuItems?.map(({path, title: itemTitle}) => ({path, title: itemTitle, routed: false})) || [];

  const menuListItems = routed ? menuItems : menuItemsRoutedFalse();

  return (
    <CollapsibleSection
      className={classNames(styles.collapsibleSection, className, {
        [styles.experienceEverywhere]: experienceEverywhere,
      })}
      title={title}
      isOpen={false}
    >
      {menuListItems?.map((item) => (
        <NavbarLink
          key={item.title}
          to={item.path}
          title={item.title}
          routed={item.routed}
          className={classNames(styles.drawerSubLink, {
            [styles.disabled]: item.disabled,
            [styles.experienceEverywhere]: experienceEverywhere,
          })}
        />
      ))}
    </CollapsibleSection>
  );
};

export default MobileNavbarMenu;
